// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__2agOU","tooltip__title":"tooltip_tooltip__title__20-QZ","triangle":"tooltip_triangle__2Zx6E"};